export const de: Record<string, string> = {
  app_subtitle: 'Finde dein nächstes Spiel basierend auf Zeit und Budget.',
  steam_id_placeholder: 'Steam64 ID eingeben (z.B. 76561198012345678)',
  fetch_wishlist: 'Liste laden',
  landing_help: 'Steam-Profil und Wunschliste müssen <strong>öffentlich</strong> sein.',
  landing_disclaimer: 'Fan-Projekt, nicht mit <a href="https://store.steampowered.com" target="_blank" rel="noopener">Valve</a>, <a href="https://www.gog.com" target="_blank" rel="noopener">GOG</a> oder <a href="https://howlongtobeat.com" target="_blank" rel="noopener">HLTB</a> verbunden. Quellcode <a href="https://github.com/t0mg/howlong">auf GitHub</a>.',
  loading_games_enriched: '{count} / {total} Spiele verarbeitet ({percent}%)',
  loading_throttled_title: 'Steam limitiert Anfragen',
  loading_waiting: 'Warte {time}...',
  loading_stop: 'Stopp & Anzeigen',
  loading_stopping: 'Wird gestoppt...',
  loading_fetching_appid: 'Lade AppIDs...',
  loading_fetching_prices: 'Lade Preise...',
  loading_fetching_details: 'Lade Spieldetails...',
  loading_fetching_details_count: 'Lade Details für {count} Spiele...',
  loading_enriching: 'Frage HowLongToBeat ab...',
  loading_enriching_gog: 'Frage GOG ab...',
  error_wishlist_private: 'Wunschliste ist leer oder privat.',
  error_no_details: 'Konnte keine Details laden.',
  error_unexpected: 'Ein unerwarteter Fehler ist aufgetreten.',
  error_try_again: 'Erneut versuchen',
  dashboard_change_id: '← Steam ID ändern',
  dashboard_lucky: 'Auf gut Glück!',
  dashboard_insights: 'Einblicke',
  dashboard_filter_label: 'Filter:',
  dashboard_filter_all: 'Alle Kategorien',
  dashboard_sort_label: 'Sortieren nach:',
  dashboard_match_info: 'HLTB Daten für {found} / {total} Spiele gefunden',
  dashboard_hltb_warning: '⚠️ Einige HLTB Daten konnten nicht geladen werden.',
  lucky_title: 'Auf gut Glück!',
  lucky_desc: 'Lass den Zufall dein nächstes Spiel wählen.',
  lucky_too_long: 'Kürzer',
  lucky_not_in_mood: 'Anderes Genre',
  lucky_too_expensive: 'Günstiger',
  lucky_ok: 'Schließen',
  lucky_empty: 'Leider keine Spiele mehr übrig!',
  stats_games: 'Spiele',
  stats_main: 'Hauptstory',
  stats_main_extra: 'Story + Extras',
  stats_completionist: '100% Abschluss',
  stats_value: 'Gesamtwert',
  stats_savings: 'Gesparte Beträge',
  sort_priority: 'Priorität',
  sort_dateAdded: 'Hinzugefügt am',
  sort_name: 'Name',
  sort_hltbMain: 'Spielzeit (Story)',
  sort_hltbMainExtra: 'Spielzeit (Story+)',
  sort_hltbCompletionist: 'Spielzeit (100%)',
  sort_priceFinal: 'Preis',
  sort_discountPercent: 'Rabatt',
  settings_title: 'Einstellungen',
  settings_desc: 'Verwalte deine Anwendungseinstellungen.',
  settings_region_label: 'Steam Region',
  settings_region_desc: 'Wähle deine Region für genaue Preise.',
  settings_lang_label: 'Sprache',
  settings_lang_desc: 'Wähle deine bevorzugte Sprache.',
  settings_clear_hltb_label: 'HLTB Daten löschen',
  settings_clear_hltb_desc: 'Zwingt die App, Spielzeiten neu zu laden.',
  settings_clear_hltb_btn: 'HLTB löschen',
  settings_cleared: 'Gelöscht!',
  settings_clear_steam_label: 'Steam Daten löschen',
  settings_clear_steam_desc: 'Entfernt Metadaten aus dem Cache.',
  settings_clear_steam_btn: 'Steam löschen',
  settings_clear_gog_label: 'GOG-Daten löschen',
  settings_clear_gog_desc: 'Zwischengespeicherte GOG-Metadaten und Preise entfernen.',
  settings_clear_gog_btn: 'GOG löschen',
  settings_clear_hidden_label: 'Versteckte Spiele löschen',
  settings_clear_hidden_desc: 'Alle zuvor versteckten Spiele wieder einblenden.',
  settings_clear_hidden_btn: 'Löschen',
  settings_hard_reset_label: 'Cache leeren (Reset)',
  settings_hard_reset_desc: 'Setzt die gesamte Anwendung zurück.',
  settings_hard_reset_btn: 'Reset',
  settings_hard_reset_confirm: 'Bist du sicher?',
  settings_close: 'Schließen',
  insights_title: 'Wunschlisten-Einblicke',
  insights_desc: 'Eine datengetriebene Übersicht deiner Wunschliste.',
  insights_avg_price_hr: 'Preis/Stunde',
  insights_oldest_entry: 'Ältester Eintrag',
  insights_top_genre: 'Top Genre',
  insights_total_story: 'Gesamte Story',
  insights_chart_duration: 'Spielzeit-Verteilung (Std)',
  insights_chart_price: 'Preis-Verteilung ({currency})',
  insights_chart_genre: 'Beliebte Genres',
  insights_chart_year: 'Hinzugefügt pro Jahr',
  insights_chart_store: 'Bester Preis: Steam vs GOG',
  game_coming_soon: 'Demnächst',
  game_demo: 'Demo',
  game_demo_avail: 'Demo verf.',
  game_added: 'Hinzugefügt: {date}',
  game_free: 'Kostenlos',
  game_unavailable: 'Nicht verfügbar',
  game_cached: '(Cache)',
  game_price_na: 'Preis N/A',
  game_no_hltb: 'Keine HLTB Daten',
  game_hltb_pending: 'Suche...',
  game_link_steam: 'Steam',
  game_link_hltb: 'HLTB',
  game_link_gog: 'GOG',
  dashboard_filter_hidden: 'Versteckte Spiele',
  game_link_hide: 'Ausblenden',
  game_link_unhide: 'Einblenden',
  hide_confirm_title: 'Spiel ausblenden',
  hide_confirm_desc: 'Bist du sicher, dass du dieses Spiel ausblenden möchtest? Es wird aus deinen Listen entfernt, aber weiterhin verfolgt.',
  hide_confirm_btn: 'Ausblenden',
  hide_cancel_btn: 'Abbrechen',
};
